// extracted by mini-css-extract-plugin
export var controls = "controls-module--controls--2NZUM";
export var bgsvg = "controls-module--bgsvg--2A8e9";
export var bgdark = "controls-module--bgdark--25hcb";
export var flex = "controls-module--flex--1lqD8";
export var btn = "controls-module--btn--3rn2O";
export var btna = "controls-module--btna--1NmLB";